/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unit_For_TreeInputs */

const en_unit_for_tree = /** @type {(inputs: Unit_For_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trees`)
};

const ar_unit_for_tree = /** @type {(inputs: Unit_For_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أشجار`)
};

const de_unit_for_tree = /** @type {(inputs: Unit_For_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bäume`)
};

const es_unit_for_tree = /** @type {(inputs: Unit_For_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`árboles`)
};

const fr_unit_for_tree = /** @type {(inputs: Unit_For_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`arbres`)
};

const it_unit_for_tree = /** @type {(inputs: Unit_For_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`alberi`)
};

const ja_unit_for_tree = /** @type {(inputs: Unit_For_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本`)
};

const ko_unit_for_tree = /** @type {(inputs: Unit_For_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그루`)
};

const pt_br_unit_for_tree = /** @type {(inputs: Unit_For_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`árvores`)
};

const ru_unit_for_tree = /** @type {(inputs: Unit_For_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`деревьев`)
};

const th_unit_for_tree = /** @type {(inputs: Unit_For_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้น`)
};

const tr_unit_for_tree = /** @type {(inputs: Unit_For_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ağaç`)
};

const zh_cn_unit_for_tree = /** @type {(inputs: Unit_For_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`棵`)
};

const zh_tw_unit_for_tree = /** @type {(inputs: Unit_For_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`棵`)
};

/**
* | output |
* | --- |
* | "trees" |
*
* @param {Unit_For_TreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const unit_for_tree = /** @type {((inputs?: Unit_For_TreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unit_For_TreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unit_for_tree(inputs)
	if (locale === "ar") return ar_unit_for_tree(inputs)
	if (locale === "de") return de_unit_for_tree(inputs)
	if (locale === "es") return es_unit_for_tree(inputs)
	if (locale === "fr") return fr_unit_for_tree(inputs)
	if (locale === "it") return it_unit_for_tree(inputs)
	if (locale === "ja") return ja_unit_for_tree(inputs)
	if (locale === "ko") return ko_unit_for_tree(inputs)
	if (locale === "pt_br") return pt_br_unit_for_tree(inputs)
	if (locale === "ru") return ru_unit_for_tree(inputs)
	if (locale === "th") return th_unit_for_tree(inputs)
	if (locale === "tr") return tr_unit_for_tree(inputs)
	if (locale === "zh_cn") return zh_cn_unit_for_tree(inputs)
	return zh_tw_unit_for_tree(inputs)
});